import { MarketingLayout } from "@/components/MarketingLayout";
import { PageHeader } from "@/components/ui/PageHeader";
import { AuditForm } from "@/components/audit/AuditForm";

export default function AuditNew() {
  return (
    <MarketingLayout>
      <div className="max-w-xl mx-auto w-full px-6 pb-16">
        <PageHeader
          title="Free Amazon"
          accent="reputation audit."
          subtitle="Paste a few of your products. We check the reviews and flag the ones that look removable under Amazon's rules."
        />
        <div className="mt-8 rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
          <AuditForm />
        </div>
      </div>
    </MarketingLayout>
  );
}
